import { useApiQuery } from '../useApiQuery';
import { apiGet, operationsClient } from '@/lib/api';
import { opsProposalEndpoints } from '@/lib/api/endpoints';
import { opsProposalKeys } from '@/lib/queryKeys';
import type { Proposal } from '@/types/proposal';

/**
 * Fetches a single proposal by ID from the operations microservice.
 */
export function useProposal(id: string) {
  return useApiQuery<Proposal>({
    queryKey: opsProposalKeys.detail(id),
    queryFn: () => apiGet<Proposal>(operationsClient, opsProposalEndpoints.detail(id)),
    enabled: Boolean(id),
  });
}
